// Vista de un HTML de correo en un iframe aislado. Sin `allow-scripts`: nada del correo
// puede ejecutarse; `allow-same-origin` solo se usa para medir la altura del contenido.
import type { JSX } from "react";
import { useEffect, useRef, useState } from "react";

export function EmailFrame({ html, src, width = "100%", minHeight = 200, autoHeight = true, title = "Vista previa del correo", className }: {
  html?: string; src?: string; width?: number | string; minHeight?: number; autoHeight?: boolean; title?: string; className?: string;
}): JSX.Element {
  const ref = useRef<HTMLIFrameElement>(null);
  const [h, setH] = useState(minHeight);
  useEffect(() => { setH(minHeight); }, [html, src, minHeight]);
  const measure = (): void => {
    if (!autoHeight) return;
    try {
      const doc = ref.current?.contentDocument;
      if (doc?.body) setH(Math.max(minHeight, doc.documentElement.scrollHeight, doc.body.scrollHeight));
    } catch { /* origen distinto: altura fija */ }
  };
  return (
    <iframe
      ref={ref}
      title={title}
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      referrerPolicy="no-referrer"
      {...(html !== undefined ? { srcDoc: html } : {})}
      {...(src !== undefined ? { src } : {})}
      onLoad={() => { measure(); setTimeout(measure, 400); }}
      style={{ width, height: autoHeight ? h : minHeight, border: 0, display: "block", margin: "0 auto", background: "#fff" }}
      className={className}
    />
  );
}

/** Miniatura escalada del correo (lista de campañas). Carga perezosa. */
export function EmailThumb({ src }: { src: string }): JSX.Element {
  return (
    <div className="relative w-9 h-11 overflow-hidden rounded border border-line bg-white shrink-0" aria-hidden="true">
      <iframe title="" src={src} sandbox="" loading="lazy" tabIndex={-1} referrerPolicy="no-referrer"
        style={{ width: 640, height: 800, border: 0, transform: "scale(0.056)", transformOrigin: "0 0", pointerEvents: "none" }} />
    </div>
  );
}
